var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 pa-5 border"},[_c('simple-table',{attrs:{"table-title":_vm.$ucfirst(_vm.$t('dss.algorithmInputs')),"headers":['Property', 'Variable', 'Value'],"table-modifier-classes":['dss'],"rows":_vm.rows}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }